import styled from '@emotion/styled';
import { ContentH3, ContentH4 } from 'src/domains/layouts/shared/typography/Content.style';

export const PageHeader = styled(ContentH3, { label: 'PageHeader' })`
    margin-bottom: 20px;
`;

export const FormHeader = styled(ContentH4, { label: 'FormHeader' })`
    margin-bottom: 32px;
`;
